<div class="tab-rules">
  <div class="tab-rules__column bottom-spacer">
    <mat-card appearance="outlined" class="tab-rules__description">
      <p class="header">Tournament Rules</p>
      <div class="rules mb--3" [innerHTML]="tournamentRules"></div>
    </mat-card>
    <div class="LEPInfo">
      <mat-icon>info</mat-icon>
      @if (isLEP) {
        <p class="info">
          Prize tournaments are all against all. You might play against players
          with higher skills than you.
        </p>
      } @else {
        <p class="info">
          Cash tournaments are all against all. You might play against players
          with higher skills than you.
        </p>
      }
    </div>
    <ng-container *ngTemplateOutlet="playControls"></ng-container>
  </div>
  <div class="tab-rules__column summary">
    <fz-score-summary
      [eventCode]="eventCode"
      [showSummary]="user?.user !== null && user?.user !== undefined"
      [prizeImage]="prizeImage"
      [isLEP]="isLEP"
      [seats]="eventScheduleDetails?.totalEntryCount"
      [bestScore]="bestScores"
      [prizeValue]="eventScheduleDetails?.firstPrize?.prizeValue"
      [entryAmount]="eventScheduleDetails?.entryAmount"
      [eventScheduleDetails]="eventScheduleDetails"
      [metadata]="details?.metadata"
    ></fz-score-summary>
  </div>
</div>
